/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { evaluateDependencies } from './dependenciesEvaluate.generated.js';
import { createParserClass } from '../../factoriesAny.js';
export var ParserDependencies = {
  evaluateDependencies,
  createParserClass
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesParserClass.generated.js
// module id = C+RQ
// module chunks = 3